import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

class Thanks extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-sm-12">
          <h1>
            <FormattedMessage
              id="app.paymentsuccess.title"
              defaultMessage="Maksu onnistui"
            />
          </h1>
          <p>
            <FormattedMessage
              id="app.paymentsuccess.text"
              defaultMessage="Lasku on nyt maksettu."
            />
          </p>
          <p>
            <Link to={"/dashboard"} className={"btn btn-primary"}>
              <FormattedMessage
                id="app.paymentsuccess.return"
                defaultMessage="Palaa etusivulle"
              />
            </Link>
          </p>
        </div>
      </div>
    );
  }
}

export default Thanks;



// WEBPACK FOOTER //
// ./src/containers/Payment/Thanks.js